import { render, staticRenderFns } from "./TemplateEmail.vue?vue&type=template&id=e1979286"
import script from "./TemplateEmail.vue?vue&type=script&lang=js"
export * from "./TemplateEmail.vue?vue&type=script&lang=js"
import style0 from "./TemplateEmail.vue?vue&type=style&index=0&id=e1979286&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports